import React from 'react';
import PropTypes from 'prop-types';

const SmallLoader = ({ loading }) => (
    <div className={`smallload${loading ? '' : ' loaded'}`}
        style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%',   // full height of parent
            width: '100%'     // full width of parent
        }}
    >
        <div className="smallload__icon-wrap">
            <svg className="load__icon">
                <path fill="#4ce1b6" d="M12,4V2A10,10 0 0,0 2,12H4A8,8 0 0,1 12,4Z" />
            </svg>
        </div>
    </div>
);

SmallLoader.propTypes = {
    loading: PropTypes.bool,
};

SmallLoader.defaultProps = {
    loading: false,
};

export default SmallLoader;
